import { c as _c } from "react/compiler-runtime";
const Email = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42.25 8.75v30.5H5.75V8.75h36.5zM9.749 16.828V35.25h28.5V16.829L24 28.185 9.749 16.828zM36.95 12.75H11.049L24 23.07l12.95-10.32z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Email;